import { render, staticRenderFns } from "./Item21.vue?vue&type=template&id=ec11271a&scoped=true&"
import script from "./Item21.vue?vue&type=script&lang=js&"
export * from "./Item21.vue?vue&type=script&lang=js&"
import style0 from "./Item21.vue?vue&type=style&index=0&id=ec11271a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec11271a",
  null
  
)

export default component.exports